/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';

const URL = process.env.REACT_APP_API_URL;

export default {
  confirm(params) {
    return axios.post(`${URL}/api/v1/users/confirm`, params);
  },
  getMe() {
    return axios.get(`${URL}/api/v1/users/me`);
  },
  async getRoles() {
    const { items } = await axios.get(`${URL}/api/v1/roles`, { params: { limit: 1000 } });
    return items;
  },
  getUsers(params) {
    return axios.get(`${URL}/api/v1/users`, { params });
  },
  deleteUser(id) {
    return axios.delete(`${URL}/api/v1/users/${id}`)
  },
  createUser(params) {
    return axios.post(`${URL}/api/v1/users`, params);
  },
  updateUser(id, params) {
    return axios.put(`${URL}/api/v1/users/${id}`, params);
  },
  resendInvite(id) {
    return axios.post(`${URL}/api/v1/users/resend-invite/${id}`);
  },
  changePassword(params) {
    return axios.post(`${URL}/api/v1/users/change-password`, params);
  },
};
